import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { BASE_URL } from "../env";
import BootstrapTable from "react-bootstrap-table-next";
import { useHistory, useParams } from "react-router-dom";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import filterFactory, {
	textFilter,
	selectFilter,
} from "react-bootstrap-table2-filter";
import ToolkitProvider, {
	CSVExport,
	Search,
} from "react-bootstrap-table2-toolkit";

const { SearchBar } = Search;
const { ExportCSVButton } = CSVExport;
const AllTablehybridresultsbybatch = () => {
	const location = useLocation();
	console.log(location);

	const [courseData, setCourseData] = useState([]);
	const [tabledata, settabledata] = useState([]);
	const [title, setTitle] = useState([]);

	useEffect(() => {
		let values = location.state.join(",");
		fetch(BASE_URL + "/hybridresultsbyexamsIdsbatch/" + values, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				setCourseData(data?.results);
			});
	}, []);

	let newdata = [];
	useEffect(() => {
		for (var i = 0; i < courseData.length; i++) {
			let code_score = 0;
			const codescore = courseData[i].coderesults.scoring;
			for (let j = 0; j < codescore.length; j++) {
				code_score += codescore[j].score;
			}
			let quiz_score = 0;
			const quizscore = courseData[i].quizresults.score;
			for (let j = 0; j < quizscore.length; j++) {
				quiz_score += quizscore[j].score;
			}
			let correctdate = new Date(
				courseData[i]?.submitDate
			).toLocaleString();
			newdata.push({
				sno: i + 1,

				email: courseData[i].email,

				coderesults: code_score,
				startdate: courseData[i]?.startdate,
				quizresults: quiz_score,
				submitdate: correctdate.split(",")[0],
				submittime: correctdate.split(",")[1],
			});
		}
		settabledata(newdata);
		// console.log(JSON.stringify(newdata));
	}, [courseData]);

	let priceFilter;

	const columns = [
		{
			dataField: "sno",
			text: "S no.",
			sort: true,
			headerStyle: () => {
				return {
					width: "5%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
				style: {
					height: "5px",
				},
			}),
		},
		{
			dataField: "email",
			text: "Email",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "coderesults",
			text: "Code Results",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},

		{
			dataField: "quizresults",
			text: "Quiz Results",
			sort: true,
			// formatter: (cell) => <a href={`/quiz-score/${cell._id}`}> {cell.examName} </a>,
			filter: textFilter({
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "submitdate",
			text: "Submit Date",
			sort: true,
			filter: textFilter(),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "#133d6a" };
			},
		},
		{
			dataField: "submittime",
			text: "Submit Time",
			sort: true,
			filter: textFilter(),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "#133d6a" };
			},
		},
	];
	return (
		<div>
			<ToolkitProvider
				keyField={"sno"}
				data={tabledata}
				columns={columns}
				exportCSV={{
					fileName: "quizexam_results.csv",
					blobType: "text/csv;charset=ansi",
					onlyExportFiltered: true,
					exportAll: false,
				}}
				search
			>
				{(props) => (
					<div>
						<div className="d-flex justify-content-between">
							<ExportCSVButton
								{...props.csvProps}
								className="btn btn-md bg-warning my-2 "
								style={{
									borderRadius: "10px",
									marginLeft: "20px",
								}}
							>
								Download All Data
							</ExportCSVButton>
							<SearchBar
								{...props.searchProps}
								style={{
									width: "300px",
									height: "5px",
									marginRight: "20px",
								}}
							/>
						</div>
						<br />
						<BootstrapTable
							{...props.baseProps}
							filter={filterFactory()}
							// condensed
							bootstrap4
							loading
							// classes="text-white"
							striped
						/>
					</div>
				)}
			</ToolkitProvider>
		</div>
	);
};

export default AllTablehybridresultsbybatch;
